<template>
  <div class="upgrade-plans-view">
    <div class="upgrade-message">
      <div class="mx-auto d-flex align-items-center justify-content-between">
        <img
          src="@/assets/images/illustrations/plans/upgrade-icon.png"
          class="d-none d-lg-block"
          width="172"
          alt="Upgrade"
        >
        <div class="p-2 p-lg-0">
          <div class="upgrade-message-title">
            {{ $t('subscription.reach-the-limit') }}
          </div>
          <div class="upgrade-message-content">
            <div>{{ $t('subscription.pleas-upgrade-to-add-more', [$tc(feature, 10)]) }}</div>
            <div>
              <span class="text-danger font-weight-semi-bold">{{ currentPackageName }}</span> {{ $t('subscription.is-limited-to', [limit, $te(feature) ? $tc(feature, limit) : feature]) }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <plans-cycle-switch v-model="cycle" />
    <pricing-cards
      hide-teaser
      show-custom
      for-upgrade
      :starred-feature="featureSlug"
      :monthly="cycle === 'monthly'"
      @select="handleSelectPackage"
    />
  </div>
</template>

<script>
import PricingCards from '@/views/admin/purchase/components/PricingCards'
import PlansCycleSwitch from '@/views/admin/purchase/components/PlansCycleSwitch'
import LocalizationService from '@/services/localization-service'

export default {
  name: 'UpgradePlansView',
  components: { PlansCycleSwitch, PricingCards },
  props: {
    feature: {
      type: String,
      default: '',
    },
    featureSlug: {
      type: String,
      default: '',
    },
    limit: {
      type: [Number, String],
      default: 1,
    },
  },
  data() {
    return {
      cycle: 'yearly',
    }
  },
  computed: {
    currentPackageName() {
      return LocalizationService.getTranslate(this.$store.getters['subscription/currentPackage'], 'title')
    },
  },
  methods: {
    handleSelectPackage(plan) {
      this.$emit('select', { planId: plan?.id, cycle: this.cycle })
    },

  },
}
</script>

<style lang="scss">
.upgrade-plans-view {

  .upgrade-message {
    margin-bottom: 40px;
    background-color: #fafafa;
    color: var(--purple);
    font-size: 18px;

    .upgrade-message-title {
      font-size: 28px;
      font-weight: 700;
      padding: 0 15px;
    }

    .upgrade-message-content {
      padding: 0 15px;
    }

    & > div {
      max-width: 730px;
    }

    .dark-layout & {
      background-color: var(--theme-dark-body-bg);
    }
  }
}
</style>
